<template>
  <b-button
    :variant="buttonProperties.disabled ? 'secondary' : 'primary'"
    class="copy-button"
    :class="buttonProperties.loading ? 'button-copying' : null"
    :type="type"
    :disabled="buttonProperties.disabled"
    @click="onClick"
  >
    <div class="d-flex align-items-center">
      <b-spinner class="mr-1 copy-spinner" v-if="buttonProperties.loading" />
      <copy-icon class="mr-1" v-else />
      <span>{{ buttonProperties.label }}</span>
    </div>
  </b-button>
</template>

<script>
  import { BButton, BSpinner } from 'bootstrap-vue';
  import CopyIcon from '@/@core/components/svg/button/Copy.vue';

  import { reactive, getCurrentInstance } from '@vue/composition-api';

  export default {
    components: {
      BButton,
      CopyIcon,
      BSpinner,
    },
    props: {
      btnLabel: { type: String, default: 'Copy to' },
      type: { type: String, default: 'button' },
    },

    setup(props) {
      const vm = getCurrentInstance().proxy;
      const buttonProperties = reactive({
        loading: false,
        disabled: false,
        label: props.btnLabel,
      });

      const onClick = () => {
        vm.$emit('onClick', buttonProperties);
      };

      return { buttonProperties, onClick };
    },
  };
</script>

<style scoped>
  .copy-button {
    padding: 0.786rem 10px;
  }

  .copy-spinner {
    width: 22px;
    height: 22px;
  }

  .button-copying {
    padding: 0.786rem 12px;
  }

  .copy-button svg {
    fill: var(--button-primary-font);
  }
  /* .save-button,
  .save-button:focus {
    background-color: #37be69 !important;
    border-color: #37be69 !important;
    color: white !important;
  }

  .save-button {
    padding: 15px 24px;
  }

  .save-button:hover:not(.disabled):not(:disabled) {
    box-shadow: 0 8px 25px -8px #37be69 !important;
  } */
</style>
